import { useState } from 'react';
const useLocalStorage = () => {
    const [isChanged, setIsChanged] = useState(false);
    const getItem = (type) => {
        const val = localStorage.getItem(type);
        return JSON.parse(val) || '';
    };
    const setItem = (type, value) => {
        localStorage.setItem(type, JSON.stringify(value));
        setIsChanged(!isChanged);
    };
    const deleteItem = (type) => {
        localStorage.removeItem(type);
        setIsChanged(!isChanged);
    };
    return { getItem, setItem, deleteItem, isChanged };
};
export default useLocalStorage;
